import { render, staticRenderFns } from "./EditUserParameter.vue?vue&type=template&id=7823223c"
import script from "./EditUserParameter.vue?vue&type=script&lang=js"
export * from "./EditUserParameter.vue?vue&type=script&lang=js"
import style0 from "./EditUserParameter.vue?vue&type=style&index=0&id=7823223c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports